export const FETCH_USER = 'FETCH_USER';
export const LOGGED_IN_USER = 'LOGGED_IN_USER';
export const LOGOUT_USER = 'LOGOUT_USER';
